var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#de4c36",
      fillOpacity: 1
    },
    d: "M68.68 31.883 38.117 1.32a4.505 4.505 0 0 0-6.375 0l-6.347 6.348 8.05 8.05A5.348 5.348 0 0 1 38.953 17a5.356 5.356 0 0 1 1.274 5.543l7.757 7.758a5.364 5.364 0 0 1 5.543 1.273 5.366 5.366 0 0 1 0 7.586 5.359 5.359 0 0 1-7.586 0 5.362 5.362 0 0 1-1.168-5.836l-7.238-7.234v19.043a5.428 5.428 0 0 1 1.418 1.012 5.366 5.366 0 0 1-7.586 7.59 5.37 5.37 0 0 1 0-7.59 5.426 5.426 0 0 1 1.758-1.168v-19.22a5.375 5.375 0 0 1-1.758-1.171 5.358 5.358 0 0 1-1.152-5.863l-7.938-7.938L1.32 31.738a4.51 4.51 0 0 0 0 6.38L31.883 68.68a4.513 4.513 0 0 0 6.375 0L68.68 38.258a4.505 4.505 0 0 0 0-6.375"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/git.cb6e5f029e7a0270187d860834912eb1.svg";
export { ForwardRef as ReactComponent };